import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '/sys',
    name: 'System',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/sys/tenant',
    meta: {
      title: '系统管理',
    },
    children: [
      {
        path: 'client',
        name: 'SystemClientList',
        component: () => import('./client/index.vue'),
        meta: {
          title: '客户端管理',
          auth: true,
          isKeepAlive: true,
        },
      },
      {
        path: 'client/:id',
        name: 'SystemClientDetail',
        component: () => import('./client/detail.vue'),
        meta: {
          title: '客户端详情',
          auth: true,
          activeMenu: 'SystemClientList',
        },
      },
      {
        path: 'tenant',
        name: 'SystemTenantList',
        component: () => import('./tenant/list.vue'),
        meta: {
          title: '租户管理',
          auth: true,
          isKeepAlive: true,
        },
      },
      {
        path: 'tenant/:id',
        name: 'SystemTenantDetail',
        component: () => import('./tenant/detail.vue'),
        meta: {
          title: '租户详情',
          auth: true,
          activeMenu: 'SystemTenantList',
          isKeepAlive: false,
        },
      },
      {
        path: 'menu',
        name: 'SystemMenuList',
        component: () => import('./menu/index.vue'),
        meta: {
          title: '菜单管理',
          auth: true,
          isKeepAlive: true,
        },
      },
      {
        path: 'role',
        name: 'SystemRoleList',
        component: () => import('./role/index.vue'),
        meta: {
          title: '角色管理',
          auth: true,
          isKeepAlive: true,
        },
      },
      {
        path: 'role/:id',
        name: 'SystemRoleDetail',
        component: () => import('./role/detail.vue'),
        meta: {
          title: '角色详情',
          auth: true,
          activeMenu: 'SystemRoleList',
          isKeepAlive: false,
        },
      },
      {
        path: 'permission',
        name: 'SystemPermissionList',
        component: () => import('./permission/index.vue'),
        meta: {
          title: '权限码管理',
          auth: true,
          isKeepAlive: true,
        },
      },
      {
        path: 'test',
        name: 'SystemTest',
        component: () => import('./test/index.vue'),
        meta: {
          title: '测试',
          auth: true,
          isKeepAlive: true,
        },
      }
    ],
  },
] as IRouteConfig[];
